import { useQuery } from '@tanstack/react-query';
import { ProductSalesCondition } from '@interfaces/models/product-sales-condition';
import { GlobalQueryKeys } from '@enums/react-query-keys';
import { usePreferences } from '@context/preferences.context';
import { getProductSalesCondition } from '@api/static';

const PLACEHOLDER_PRODUCT_SALES_CONDITION: ProductSalesCondition = {
  categorySizeStandard: {},
  sizeStandard: 'US',
};

const useProductSalesConditionQuery = () => {
  const { siteId, locale } = usePreferences();

  const { data: productSalesCondition } = useQuery<ProductSalesCondition>({
    queryKey: [GlobalQueryKeys.PRODUCT_SALES_CONDITION, siteId, locale],
    queryFn: () => getProductSalesCondition({ siteId, locale }),
    refetchOnMount: false,
  });

  return productSalesCondition ?? PLACEHOLDER_PRODUCT_SALES_CONDITION;
};

export default useProductSalesConditionQuery;
